// extracted by mini-css-extract-plugin
module.exports = {"button":"jut__TreeNodeCollapseAll__button"};